<template>
  <el-dialog title="微信支付" :visible.sync="visible" width="400px" :before-close="handleClose">
    <div class="buy-modal">
      <div class="title">{{ name }}</div>
      <div class="row">
        <div class="label">应付金额：</div>
        <div class="value">{{ price }}</div>
      </div>
      <canvas v-if="qrCode" id="canvasId" @click.stop="goPay" />
      <!-- 测试接口，暂时关闭 -->
      <!-- <div v-if="orderNo" class="order_status">等待支付</div> -->
    </div>
  </el-dialog>
</template>
<script>
import { getOrderStatus, wxPay } from "@/api/admin/w_x.js";
import QRCode from "qrcode";
import { notEmpty } from "@/utils/type";
import { clearTimer, saveTimer } from "@/utils/timer";

export default {
  name: "WxPayQrCode",
  props: [],
  data() {
    return {
      visible: false,
      loading: false,
      name: "",
      priceId: null,
      price: "",
      qrCode: "",
      loading: false,
      orderNo: "",
      statusLoader: false,
      orderTimer: null,
    };
  },
  methods: {
    initData() {
      this.name = "";
      this.price = "";
      this.priceId = "";
      this.qrCode = "";
      this.orderNo = "";
      if (this.orderTimer) {
        clearTimer("wxOrder");
      }
    },
    open(data) {
      if (data.goodsId && data.name) {
        this.name = data.name;
        this.price = data.price;
        this.priceId = data.goodsId;
        this.visible = true;
        this.goPay();
      } else {
        this.$message.error("应用信息不完整，无法购买!");
        this.visible = false;
      }
    },
    handleClose() {
      this.visible = false;
      this.initData();
    },
    goPay() {
      this.qrCode = "";
      wxPay(this.priceId).then(res => {
        if (notEmpty(res.data)) {
          this.qrCode = res.data.codeUrl;
          this.orderNo = res.data.orderNo;
          if (this.qrCode) {
            this.$nextTick(() => {
              QRCode.toCanvas(document.getElementById("canvasId"), this.qrCode, { width: 200, height: 200 });
            });
          }
          this.requestOrderStatus();
        }
      });
    },
    requestOrderStatus() {
      clearTimer("wxOrder");
      if (this.orderNo) {
        getOrderStatus(this.orderNo)
          .then(res => {
            let data = res.data;
            if (data && isObject(data) && data.orderStatus === "支付成功") {
              this.$store.commit("SET_WX_PAY_SUCCESS", true);
              clearTimer("wxOrder");
              this.handleClose();
            } else {
              this.orderTimer = setTimeout(() => {
                if (this.orderNo) {
                  this.requestOrderStatus();
                }
              }, 2000);
              saveTimer(this.orderTimer, "wxOrder");
            }
          })
          .catch(err => {
            console.error(err);
          });
      }
    },
  },
  beforeDestroy() {
    clearTimer("wxOrder");
  },
};
</script>
<style lang="less" scoped>
@import "./wxPayQrCode.less";
</style>
